<template>
  <section>
    <el-col :span="24" style="padding-bottom: 0;" size="small">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-autocomplete v-model="filters.func" :fetch-suggestions="querySearch" size="small"
                           placeholder="功能"></el-autocomplete>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="queryBtn()" size="small" icon="el-icon-search" :disabled="!isFun">
            查询
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd" size="small" icon="el-icon-plus"
                     :disabled="!isAuth('feature:add')">新增
          </el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="featureList" highlight-current-row v-loading="listLoading" @selection-change="selsChange"
              style="width: 100%;" size="small">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column type="index" width="60"></el-table-column>
      <el-table-column prop="feature" label="功能" width="200" align="center"></el-table-column>
      <el-table-column prop="bit" label="Bit" width="100" align="center"></el-table-column>
      <el-table-column prop="activeMode" label="激活方式" width="100" align="center">
        <template slot-scope="scope">
          {{scope.row.activeMode === 1 ? '旷视激活':'内部激活' }}
        </template>
      </el-table-column>
      <el-table-column prop="description" label="备注" min-width="200" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="english" label="英语备注" min-width="200" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" width="150" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleEdit(scope.$index, scope.row)"
                     :disabled="!isAuth('feature:update')">编辑
          </el-button>
          <el-button type="text" size="small" @click="handleDel(scope.$index, scope.row)"
                     :disabled="!isAuth('feature:del')">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24">
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10"
                     :total="total" :current-page.sync="page" style="float:right;">
      </el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false" width="30%">
      <el-form :model="editForm" label-width="80px" ref="editForm" size="small" :rules="editFormRules">
        <el-form-item label="功能" prop="feature">
          <el-input v-model="editForm.feature" maxlength="15"></el-input>
        </el-form-item>
        <el-form-item label="Bit" prop="bit">
          <el-input v-model="editForm.bit"></el-input>
        </el-form-item>
        <el-form-item label="激活方式" prop="activeMode">
          <el-select v-model="editForm.activeMode" placeholder="请选择激活方式" style="width:100%">
            <el-option label="内部激活" :value="0"></el-option>
            <el-option label="旷视激活" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="description">
          <el-input v-model="editForm.description"></el-input>
        </el-form-item>
        <el-form-item label="英语备注" prop="english">
          <el-input v-model="editForm.english"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading" size="small">提交</el-button>
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false" width="30%">
      <el-form :model="addForm" label-width="80px" ref="addForm" size="small" :rules="addFormRules">
        <el-form-item label="功能" prop="feature">
          <el-input v-model="addForm.feature" maxlength="15"></el-input>
        </el-form-item>
        <el-form-item label="Bit" prop="bit">
          <el-input v-model="addForm.bit"></el-input>
        </el-form-item>
        <el-form-item label="激活方式" prop="activeMode">
          <el-select v-model="addForm.activeMode" placeholder="请选择激活方式" style="width:100%">
            <el-option label="内部激活" :value="0"></el-option>
            <el-option label="旷视激活" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="description">
          <el-input v-model="addForm.description"></el-input>
        </el-form-item>
        <el-form-item label="英语备注" prop="english">
          <el-input v-model="addForm.english"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading" size="small">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import {getFeatureList, removeFeature, addFeature, modifyFeature, getDeviceList} from "../../../api/api";
import {isAuth} from "../../../utils";

export default {
  data() {
    return {
      filters: {
        func: ""
      },
      isFun: false,
      featureList: [],
      features: [],
      total: 0,
      page: 1,
      listLoading: false,
      editFormVisible: false,//编辑界面是否显示
      editLoading: false,
      editForm: {
        id: "",
        feature: "",
        bit: "",
        description: "",
        activeMode: "",
        english: ""
      },
      editFormRules: {
        feature: [{
          required: true,
          message: "请输入功能名称",
          trigger: "blur"
        }],
        activeMode: [{
          required: true,
          message: "请选择激活方式",
          trigger: "change"
        }],
        bit: [{
          required: true,
          message: "请输入功能Bit值",
          trigger: "blur"
        },{
          pattern: /^(0|[1-9]\d*)$/,
          message: "请输入大于等于0的整数",
          trigger: "blur"
        }]
      },

      addFormVisible: false,//新增界面是否显示
      addLoading: false,
      addForm: {
        feature: "",
        bit: "",
        description: "",
        activeMode: 0,
        english: ""
      },
      addFormRules: {
        feature: [{
          required: true,
          message: "请输入功能名称",
          trigger: "blur"
        }],
        activeMode: [{
          required: true,
          message: "请选择激活方式",
          trigger: "change"
        }],
        bit: [{
          required: true,
          message: "请输入功能Bit值",
          trigger: "blur"
        },{
          pattern: /^(0|[1-9]\d*)$/,
          message: "请输入大于等于0的整数",
          trigger: "blur"
        }]
      }
    };
  },
  methods: {
    querySearch(queryString, cb) {
      let features = this.features;
      let results = queryString ? features.filter(this.createFilter(queryString)) : features;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (feature) => {
        return (feature.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getFeatureList();
    },

    queryBtn(){
      this.page=1;
      this.getFeatureList();
    },

    getFeatureList() {
      let para = {
        page: this.page - 1,
        size: 10,
        feature: this.filters.func
      };
      this.listLoading = true;
      getFeatureList(para).then((res) => {
        if (res.data.code === 0) {
          this.featureList = res.data.featureList.content;
          this.total = res.data.featureList.totalElements;
          this.features = [];
          for (let i = 0; i < this.featureList.length; i++) {
            let feature = {};
            feature.value = this.featureList[i].feature;
            this.features.push(feature);
          }
        } else {
          this.$message.error("获取功能列表失败，请稍后重新获取");
        }
        this.listLoading = false;
      });
    },
    //删除
    handleDel: function (index, row) {
      this.$confirm("确认删除该信息吗?", "提示", {
        type: "warning"
      }).then(() => {
        this.listLoading = true;
        let para = {
          id: row.id
        };
        removeFeature(para).then((res) => {
          if (res.data.code === 0) {
            this.$message.success("删除成功");
          } else {
            this.$message.error("删除失败");
          }
          this.listLoading = false;
          this.getFeatureList();
        });
      }).catch(() => {

      });
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
    },
    //显示新增界面
    handleAdd: function () {
      this.addFormVisible = true;
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            let para = Object.assign({}, this.editForm);
            modifyFeature(para).then((res) => {
              if (res.data.code === 0) {
                this.$message.success("修改成功");
              } else {
                this.$message.error("修改失败");
              }
              this.editLoading = false;

              this.$refs["editForm"].resetFields();
              this.editFormVisible = false;
              this.getFeatureList();
            });
          });
        }
      });
    },

    //新增
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            let para = Object.assign({}, this.addForm);
            addFeature(para).then((res) => {
              if (res.data.code === 0) {
                this.$message.success("添加成功");
              } else {
                this.$message.error("添加失败");
              }
              this.addLoading = false;

              this.$refs["addForm"].resetFields();
              this.addFormVisible = false;
              this.getFeatureList();
            });
          });
        }
      });
    },
    selsChange: function (sels) {
      this.sels = sels;
    }
  },
  activated() {
    this.isFun = isAuth("feature:list");
    if (this.isFun) {
      this.getFeatureList();
    }
  }
};
</script>

<style slot-scope>

</style>



// WEBPACK FOOTER //
// src/views/modules/conf/fun.vue